<template>
  <div class='lt-scene' ref='ltScene'>
    <TemporaryControls v-if='isDevelopment'>
      <!-- eslint-disable -->
      <div>
        <strong>window:</strong> {{ windowWidth }}x{{ windowHeight }}<br />
        <strong>scene: </strong> {{ sceneWidth }}x{{ sceneHeight }}<br />
      </div>

      <template v-slot:table>
        <tr>
          <td>Left</td>
          <td>
            <input
              v-model.number="leftPositionSelected"
              type="number"
              min='0'
              :max='maxLeft'
              step='20'
            />
          </td>
        </tr>
      </template>

      <template v-slot:footer>
        <strong>activeRefName:</strong> {{ activeRefName }}
      </template>

      <template v-slot:mini>

      </template>
      <!-- eslint-enable -->
    </TemporaryControls>

    <!-- Order of following items is important for overlaying -->
    <img class="lt-scene_background" src="../assets/background-base.svg" ref="backgroundBase" alt="" />
    <EatOutWindow ref='sect_eatout' />
    <TransportWindow ref='sect_transport' />

    <SceneItemTransition :isActive='house > 1'>
      <div class='lt-scene_coving'></div>
    </SceneItemTransition>

    <SceneItemTransition transition="slideY-down" :isActive="house > 0">
      <img
        src="../assets/art.svg"
        class='lt-scene_art'
        ref='sect_house_1'
        alt=""
      />
    </SceneItemTransition>

    <SceneItemTransition transition="slideY-down" :isActive="holiday > 0">
      <img
        src='../assets/holiday-1.svg'
        class='lt-scene_holiday-1'
        ref='sect_holiday_1'
        alt=""
      />
    </SceneItemTransition>

    <SceneItemTransition transition="slideY-down" :isActive="holiday > 1">
      <img
        src='../assets/holiday-2.svg'
        class='lt-scene_holiday-2'
        ref='sect_holiday_2'
        alt=""
      />
    </SceneItemTransition>

    <SceneItemTransition :isActive="house > 2">
      <img
        src="../assets/lamp.svg"
        class='lt-scene_lamp'
        alt=""
      />
    </SceneItemTransition>

    <div class='lt-scene_windows'></div>

    <DiningTable ref='sect_food' />

    <SceneItemTransition :isActive="house === 1">
      <Shelf ref='sect_holiday_3' />
    </SceneItemTransition>

    <SceneItemTransition transition="slideY-down" :isActive="house > 1">
      <Cupboard ref='sect_house_2' />
    </SceneItemTransition>

    <SceneItemTransition transition='slideX-left' :isActive="house > 0">
      <div class='lt-scene_sofas'></div>
    </SceneItemTransition>

    <PersonalItems ref='sect_personal' />

    <SceneItemTransition
      transition='slidex-right'
      :isActive="house > 2"
    >
      <img
        src='../assets/sideboard.svg'
        class='lt-scene_sideboard'
        ref='sect_house_3'
        alt=""
      />
    </SceneItemTransition>

    <SceneItemTransition transition="slideY-down" :isActive="treat > 0">
      <img
        src='../assets/treat-1.svg'
        class='lt-scene_treat-1'
        ref='sect_treat_1'
        alt=""
      />
    </SceneItemTransition>

    <SceneItemTransition transition="slideY-down" :isActive="treat > 1">
      <img
        src='../assets/treat-2.svg'
        class='lt-scene_treat-2'
        ref='sect_treat_2'
        alt=""
      />
    </SceneItemTransition>

    <SceneItemTransition transition="slideY-down" :isActive="treat > 2">
      <img
        src='../assets/treat-3.svg'
        class='lt-scene_treat-3'
        ref='sect_treat_3'
        alt=""
      />
    </SceneItemTransition>

    <div :class="['lt-scene_overlay', showOverlay ? 'lt-scene_overlay--active' : '']"></div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapMutations } from 'vuex';
import { mapFields } from "vuex-map-fields";
import anime from "animejs";

import TemporaryControls from "./TemporaryControls";

import SceneItemTransition from "../components/SceneItemTransition";

import Cupboard from "./scene-items/Cupboard";
import DiningTable from "./scene-items/DiningTable";
import EatOutWindow from "./scene-items/EatOutWindow";
import PersonalItems from "./scene-items/PersonalItems";
import Shelf from "./scene-items/Shelf";
import TransportWindow from "./scene-items/TransportWindow";

export default {
  components: {
    SceneItemTransition,

    Cupboard,
    DiningTable,
    EatOutWindow,
    PersonalItems,
    Shelf,
    TransportWindow,

    TemporaryControls,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      leftPositionSelected: 0,

      windowWidth: 0,
      windowHeight: 0,
      sceneWidth: 0,
      sceneHeight: 0,
    };
  },

  computed: {
    ...mapFields([
      'scene.status.treat',
      'scene.status.house',
      'scene.status.holiday',
      'ui.showForeground',
    ]),
    ...mapGetters([
      'activeItem',
      'isOnPage',
      'isDevelopment',
    ]),
    maxLeft: function() {
      return Math.abs(this.windowWidth - this.sceneWidth);
    },
    leftPosition: function() {
      const validLeftPosition = _.clamp(Math.max(0, this.leftPositionSelected), 0, this.maxLeft);
      return 0 - validLeftPosition;
    },
    showOverlay: function() {
      const isNotLoading = this.isOnPage('loading') === false;
      return isNotLoading && this.showForeground;
    },
    activeRefName: function() {
      const item = this.activeItem;

      if (item.status === 0) {
        return '';
      }
      else if (_.has(this.$refs, `sect_${item.name}_${item.status}`)) {
        return `sect_${item.name}_${item.status}`;
      }
      else if (_.has(this.$refs, `sect_${item.name}`)) {
        return `sect_${item.name}`;
      }
      return '';
    },
    loadingLoop: function() {
      const duration = this.maxLeft * 10;

      return anime({
        targets: this.$refs.ltScene,
        left: `-${this.maxLeft}px`,
        easing: "linear",
        autoplay: false,
        duration,
        loop: true,
        direction: 'alternate',
      });
    },
  },

  watch: {
    activeRefName(ref) {
      if (ref && ref.length > 0) {
        this.goTo(ref);
      }
    },
    isLoading(newVal) {
      if (newVal) {
        this.loadingLoop.play();
      }
      else {
        this.loadingLoop.pause();
      }
    },
  },

  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.getSceneDimensions);
      this.$refs.backgroundBase.onload = this.getSceneDimensions;
      this.getSceneDimensions();
    });
  },

  methods: {
    ...mapMutations([
      'applyChangesToScene',
      'setIsAnimating',
      'goToNextPage',
    ]),
    getSceneDimensions() {
      this.windowWidth = document.getElementById('ahc-lifetime-find-your-future-wrapper').clientWidth;
      this.windowHeight = document.getElementById('ahc-lifetime-find-your-future-wrapper').clientHeight;

      this.$refs.backgroundBase.style.height = '100%';

      this.sceneWidth = this.$refs.backgroundBase.clientWidth;
      this.sceneHeight = this.$refs.backgroundBase.clientHeight;

      this.tempCssRefresh = !this.tempCssRefresh;
    },

    goTo(elementRef) {
      const lastLeftPosition = this.leftPosition;

      if (this.windowWidth < this.sceneWidth) {
        const vueRef = this.$refs[`${elementRef}`];

        // If target is Vue component get it's HTML Element
        const targetElement = _.isElement(vueRef) ? vueRef : vueRef.$el;

        const targetMidPosition = targetElement.offsetLeft + (targetElement.clientWidth / 2);
        const windowMidPoint = this.windowWidth / 2;

        this.leftPositionSelected = targetMidPosition - windowMidPoint;
      }
      else {
        this.leftPositionSelected = 0;
      }

      const difference = Math.abs(this.leftPosition - lastLeftPosition);
      const duration = difference > 400 ? 300 : 150;
      const delayBeforeAddingToScene = 100;
      const itemAnimationTime = 1500;

      anime({
        targets: this.$refs.ltScene,
        translateX: ['0px', `${this.leftPosition}px`],
        easing: "linear",
        duration,
        complete: () => {
          setTimeout(() => {
            this.applyChangesToScene();

            setTimeout(() => {
              this.showForeground = true;
              this.goToNextPage();
              this.setIsAnimating(false);
            }, itemAnimationTime);

          }, delayBeforeAddingToScene)
        },
      });
    },
  },
};

</script>

<style lang='scss'>
$img-base: '../assets';

.lt-scene {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  transform: translate3d(0,0,0,0);

  // These widths look random, but in fact they match the inherited ratio of desktop view.
  // It turns out that Firefox needs a set width for this contain to accurately render the scene and position all the items.
  width: 142.5%;
  @include breakpoint-portrait {
      width: 365.4%;
  }
}

.lt-scene_background {
  height: 100%;
}

.lt-scene_windows,
.lt-scene_coving,
.lt-scene_sofas {
  @include scut-absolute(0 0 0 0);
  background: transparent no-repeat center center;
  background-size: contain;
}

.lt-scene_windows { background-image: url("#{$img-base}/background-windows.svg"); }
.lt-scene_coving { background-image: url("#{$img-base}/background-coving.svg"); }
.lt-scene_sofas { background-image: url("#{$img-base}/background-sofas.svg"); }

.lt-scene_art {
  position: absolute;
  top: proportionSize(175, $scene-height);
  left: proportionSize(700, $scene-width);
  width: proportionSize(128, $scene-width);
}

.lt-scene_holiday-1 {
  position: absolute;
  top: proportionSize(202, $scene-height);
  left: proportionSize(1016, $scene-width);
  width: proportionSize(125, $scene-width);
}

.lt-scene_holiday-2 {
  position: absolute;
  top: proportionSize(170, $scene-height);
  left: proportionSize(130, $scene-width);
  width: proportionSize(43, $scene-width);
}

.lt-scene_lamp {
  position: absolute;
  bottom: proportionSize(126, $scene-height);
  left: proportionSize(1011, $scene-width);
  width: proportionSize(156, $scene-width);
}

.lt-scene_sideboard {
  position: absolute;
  left: 0;
  bottom: 0;
  width: proportionSize(434, $scene-width);
}

.lt-scene_treat-1 {
  position: absolute;
  bottom: proportionSize(113, $scene-height);
  right: proportionSize(598, $scene-width);
  width: proportionSize(58, $scene-width);
  height: proportionSize(72, $scene-height);
}

.lt-scene_treat-2 {
  position: absolute;
  bottom: proportionSize(117, $scene-height);
  right: proportionSize(457, $scene-width);
  width: proportionSize(103, $scene-width);
  height: proportionSize(115, $scene-height);
}

.lt-scene_treat-3 {
  position: absolute;
  bottom: proportionSize(12, $scene-height);
  right: proportionSize(761, $scene-width);
  width: proportionSize(223, $scene-width);
  height: proportionSize(134, $scene-height);
}

.lt-scene_overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #6b6b6b;
  opacity: 0;
  transition: opacity 0.2s linear;
  &--active {
    opacity: 0.5;
  }
}

</style>
